import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { PipesModule } from "@vattenfall/core";
import { LoadingModule, InputModule, ErrorModule, TooltipModule } from "@vattenfall/ui";

import { ChatAppElement } from "./chat-app.element";
import { MessageAgentComponent } from "./message-agent/message-agent.component";
import { MessageBotComponent } from "./message-bot/message-bot.component";
import { MessageDownloadComponent } from "./message-download/message-download.component";
import { MessageLinksComponent } from "./message-links/message-links.component";
import { MessageOptionsComponent } from "./message-options/message-options.component";
import { MessageSwitchAgentComponent } from "./message-switch-agent/message-switch-agent.component";
import { MessageSwitchBotComponent } from "./message-switch-bot/message-switch-bot.component";
import { MessageUserComponent } from "./message-user/message-user.component";
import { MessageWarningComponent } from "./message-warning/message-warning.component";
import { MessageGroupComponent } from "./shared/message-group.component";
import { MessageTimestampComponent } from "./shared/message-timestamp.component";

@NgModule({
  declarations: [
    ChatAppElement,
    MessageAgentComponent,
    MessageBotComponent,
    MessageDownloadComponent,
    MessageLinksComponent,
    MessageUserComponent,
    MessageOptionsComponent,
    MessageSwitchAgentComponent,
    MessageSwitchBotComponent,
    MessageWarningComponent,
    MessageTimestampComponent,
    MessageGroupComponent,
  ],
  imports: [CommonModule, FormsModule, LoadingModule, InputModule, ErrorModule, TooltipModule, PipesModule],
  exports: [ChatAppElement],
  bootstrap: [ChatAppElement],
})
export class ChatAppModule {}
